import classNames from 'classnames'
import { RefObject, useEffect } from 'react'

interface Props {
  children: React.ReactNode
  contentClasses?: string
  contentRef: RefObject<HTMLDivElement>
  toogle: boolean
  toogleRef: RefObject<HTMLDivElement>
  wrapperClasses?: string
}

export default function ToogleContent(props: Props): React.ReactElement {
  const { toogleRef, contentRef, children, contentClasses = '', toogle, wrapperClasses = '' } = props

  const toogleContentClasses = classNames(contentClasses, {
    visible: toogle,
    invisible: !toogle,
  })

  useEffect(() => {
    if (toogleRef.current && contentRef.current) {
      const section = toogleRef.current
      const content = contentRef.current

      if (toogle) {
        section.style.height = `${content.scrollHeight}px`
      } else {
        section.style.height = '0px'
      }
    }
  }, [contentRef, toogle, toogleRef])

  return (
    <section className={`transition-height duration-300 h-0 ${wrapperClasses}`} ref={toogleRef}>
      <div className={toogleContentClasses} ref={contentRef}>
        {children}
      </div>
    </section>
  )
}
